import React, { useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import { FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import LoadingData from "../../Common/LoadingData";


const AllQuestions = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // setLoading(true);
    fetch(`${process.env.REACT_APP_BASE_URL}/quizzes`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setData(data.msg);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleDelete = (id) => {
    fetch(`${process.env.REACT_APP_BASE_URL}/admin/quiz/${id}`, {
      method: "DELETE",
      credentials: "include",
    })
      .then((data) => data.json())
      .then((res) => {
        console.log(res);
        if (res.status === "success") {
          setData(data.filter((item) => item._id !== id));
        } else {
          alert(res.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // if (loading) {
  //   return <LoadingData />;
  // }

  return loading ? (
    <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
      <div className="lds-dual-ring"></div>
    </div>
  ) : (
    <div className="container">
      <div className="row">
        <div className="col-md-11 m-auto">
          <div className="add-page">
            <table>
              <caption>All Questions</caption>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Delete</th>
                  <th>Edit</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item?.name}</td>
                    <td>
                      <span
                        className="delete"
                        onClick={() => handleDelete(item._id)}
                      >
                        <AiFillDelete />
                      </span>
                    </td>
                    <td>
                      <Link to={`/dashboard/edit-question/${item._id}`}>
                        <span className="edit">
                          <FaEdit />
                        </span>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllQuestions;
